import httpService from "./http.service";

class OrdersService {
  getOrdersUrl = "/orders/";
  //   ordersAC = "/order/ac";

  getOrders = () => {
    return httpService.get(this.getOrdersUrl);
  };
  getOrder = (id) => {
    return httpService.get(this.getOrdersUrl + id);
  };
  createOrder = (model) => {
    return httpService.post("/orders", model);
  };
  validatePayment = async (token) => {
    return httpService.get("/orders/verify/" + token);
  };
  editOrder = (id, model) => {
    return httpService.patch("/orders/" + id, model);
  };
  deleteOrder = (id) => {
    return httpService.delete("/orders/" + id);
  };

  sendLocation = (model) => {
    return httpService.post("/sms/location", model);
  };
}

const ordersService = new OrdersService();
export default ordersService;
